module.exports = __webpack_public_path__ + "static/img/highVacuum.d0e1371.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/highVacuum.png
// module id = 0G9x
// module chunks = 1